import EMC from './EMC.jpg';
import NextProj from './NextProj.jpg';
import COINFC from './COINFC.JPG';
import DesignThinking from './VliegendeHelpman.png';

const ProjectData = [
      {
    type: 'internal',
    url: '../contact',
    image: NextProj,
    title: 'Word jij het volgende project?',
    description: 'Plan een koffietje!',
  },
  {
    type: 'internal',
    //url: '../emotionchair',
    image: EMC,
    title: 'De E-Motion Chair',
    description: 'Onrust detectie voor mensen met dementie',
  },
  {
    type: 'internal',
    //url: '../coinfc',
    image: COINFC,
    title: 'De  COINFC',
    description: 'A businesscard at the flip of a coin!',
  },
  {
    type: 'internal',
    //url: '../designthinking',
    image: DesignThinking,
    title: 'Design Thinking Workshop',
    description: 'Training voor Stichting Vliegende Helpman',
  },
];

export default ProjectData;